<script setup>
import { ref, computed, onBeforeMount } from "vue";
import { useCompanyStore } from "@/stores/company";
import { useUiStore } from "@/stores/ui";
import { useThemesStore } from "@/stores/themes";

const uiStore = useUiStore();
const themesStore = useThemesStore();
const emit = defineEmits(["refresh"]);
const company_id = useCompanyStore().companyId;
const getModalInfo = computed(() => uiStore.modalData);
const getModalAction = computed(() => uiStore.modalAction);

let id = ref(null);
let name = ref(null);
let description = ref(null);
let properties = ref({});
let isSubmitted = ref(false);

const onSubmit = () => {
  isSubmitted.value = true;
  const data = {
    id: id.value,
    company_id,
    data: {
      name: name.value,
      description: description.value,
      properties: properties.value,
    },
  };

  themesStore
    .editTheme(data)
    .then(() => {
      isSubmitted.value = false;
      emit("refresh");
      resetStoreData();
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};

const resetStoreData = () => {
  uiStore.resetModalStore();
};

onBeforeMount(() => {
  if (getModalAction.value == "edit_theme") {
    id.value = getModalInfo.value.id;
    name.value = getModalInfo.value.name;
    description.value = getModalInfo.value.description;
    themesStore
      .fetchThemeById({ company_id, id: id.value })
      .then(async (res) => {
        name.value = res.data.name;
        description.value = res.data.description;
        if (res && res.data && res.data.properties) {
          properties.value = res.data.properties;
        }
      })
      .catch(() => {});
  }
});
</script>

<template>
  <DModal v-if="getModalAction === 'edit_theme'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Edit Theme </template>

    <template #body>
      <div class="mb-3">
        <DInput
          label="Theme Name"
          :value="name"
          @input="name = $event.target.value"
          type="text"
          width="100%"
        />
      </div>

      <FloatLabel class="w-full mb-3">
        <PTextarea
          v-model="description"
          id="description"
          class="d-textarea resize-none h-105 w-full"
          autoResize
        />
        <label for="description">Description</label>
      </FloatLabel>
    </template>
    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button
            :disabled="!name || isSubmitted"
            @click="onSubmit"
            type="button"
            class="btn btn-primary add-button mr-30"
          >
            Edit
            <span
              v-if="isSubmitted"
              class="spinner-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
          <button
            @click="resetStoreData"
            type="button"
            class="btn btn-secondary cancel-button"

          >
            Cancel
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
